// extracted by mini-css-extract-plugin
module.exports = {"page-loader":"PageLoader_page-loader__oGllM","loading":"PageLoader_loading__1oLTy"};